function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#F01919",
  d: "M2.416 8.211L0 10.421 7.893 18 24 2.211 21.745 0 7.893 13.579z"
});

var SvgCheck = function SvgCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/check.2b9ad5cf.svg";
export { SvgCheck as ReactComponent };